import React, {  useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./editRequest.css";
import { tableFormat } from "../../../config/tableFormat";
import 'react-quill/dist/quill.snow.css'; 
import moment from "moment";
import { getDistinctDataThroughSingleApi, fetchGPUData } from "../../../redux/actions/actions";
import Draggable from "../../components/tableComponent/tableComponent/Draggable";
import Select from 'react-select';
import { components } from 'react-select';
const CustomValueContainer = ({ children, ...props }) => {
  const selectedValues = props.getValue();
  const { selectProps, hasValue } = props;

  return (
    <components.ValueContainer {...props}>
      <div className="drag-tag">
        <Draggable showScroll={false}>
          {!hasValue && !props.selectProps.inputValue && (
            <div className="custom-placeholder">{selectProps.placeholder}</div>
          )}
          {selectedValues.map((val, index) => (
            <span className="tag-value" key={val.value} style={{ marginRight: '8px' }}>
              {val.label}
            </span>
          ))}
        </Draggable>
      </div>
    </components.ValueContainer>
  );
};

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: '100%',
    width: '100%',
    cursor: 'pointer',
    border: 'none',
    boxShadow: 'none'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'white' : provided.backgroundColor,
    color: state.isSelected ? 'black' : provided.color,
    cursor: 'pointer'
  }),
  valueContainer: (provided) => ({
    ...provided,
    overflowX: "scroll",
    scrollbarWidth: 'none', 
    msOverflowStyle: 'none', 
    "&::-webkit-scrollbar": {
      display: "none"
    },
    flexWrap: "unset",
    fontFamily:
      'apple-system,BlinkMacSystemFont,"Segoe UI",system-ui,"Apple Color Emoji","Segoe UI',
    fontSize: "5px",
    fontWeight: "600",
    height: "32px",
    padding: "0px 8px 0px 8px",
    width: "18.5vw",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: 'white',
    color: 'black'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'black'
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'black',
    ':hover': {
      backgroundColor: 'lightgray',
      color: 'black'
    }
  })
};

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ marginRight: '8px' }}
        />{" "}
        <label style={{ margin: 0 }}>{props.label}</label>
      </div>
    </components.Option>
  );
};
function EditRequest(props) {
  const [selectedArray, setSelectedArray] = React.useState({
    RequestID: props.data?.RequestID || null,
    RequestCode: props.data?.RequestCode || null,
    CustomerName: props.data?.CustomerName || "",
    UAT_ID: props.data?.UAT_ID || "",
    TPID: props.data?.TPID || "",
    RequestDate: props.data?.RequestDate || null,
    RequestStatus: props.data?.RequestStatus || "",
    GPU_Name: props.data?.GPU_Name || "",
    GPUsRequested: props.data?.GPUsRequested || "",
    RegionNeeded: props.data?.RegionNeeded || "",
    RegionFlexibility: props.data?.RegionFlexibility || "",
    DateNeeded: props.data?.DateNeeded || null,
    GPUsAllocated: props.data?.GPUsAllocated || "",
    GPUsOwed: props.data?.GPUsOwed || 0,
    DC_RegionAllocated: props.data?.DC_RegionAllocated || "",
    RI: props.data?.RI || "",
    EarmarkedDate: props.data?.EarmarkedDate || null,
    FullyAllocatedDate: props.data?.FullyAllocatedDate || null,
    Tag: Array.isArray(props.data?.Tag) ? props.data?.Tag.join(',') : props.data?.Tag || [],
    AIGBB: props.data?.AIGBB || "",
    LostReason: props.data?.LostReason || "",
    LostToCompetitor: props.data?.LostToCompetitor || "",
    UseCaseCategory: props.data?.UseCaseCategory || "",
    MSX_Opportunity_ID: props.data?.MSX_Opportunity_ID || "",
    MSX_Milestone_ID: props.data?.MSX_Milestone_ID || "",
  });
  

  const dispatch = useDispatch();

  const [requestStatus, setRequestStatus] = React.useState(selectedArray["RequestStatus"]);

  const [selectedGPU, setSelectedGPU] = React.useState(selectedArray['GPU_Name'] || "");
  const [errorLabel, setErrorLabel] = React.useState("");
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [errorField, setErrorField] = useState("")
   const isGPUDataLoaded = useSelector(store => store.GPUData.isGPUDataLoaded);


  const gpuWiseRegionData = useSelector(store => store.GPUData.gpuWiseRegionData !== undefined ? store.GPUData.gpuWiseRegionData : []);
  const GPUData = useSelector(store => store.GPUData.GPUData !== undefined ? store.GPUData.GPUData : []);
  const isDistinctDataThroughSingleApiLoaded = useSelector(
      (store) =>
        store.distinctDataThroughSingleApi.isDistinctDataThroughSingleApiLoaded
    );
  const requestStateOption = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RequestStatus !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RequestStatus?.map((item) => ( item["Value"]))
      : null
  );
  const riOption = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RI !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RI?.map((item) => ( item["Value"]))
      : null
  );
  const regionFlexibilityOptions = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RegionFlexibility !== undefined
      ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
      .RegionFlexibility?.map((item) => ( item["Value"])) 
      : null
  );
   const gpuOptions = useSelector((store) =>
      store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
        .GPU !== undefined
        ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
          .GPU
        : null
    );
 const allTags = useSelector((store) =>
    store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
  .Tag !== undefined
  ? store.distinctDataThroughSingleApi.distinctDataThroughSingleApi
  .Tag?.map((item) => ({
    value: item["Value"],
    label: item["Value"],
  }))
  : []
);
  const [selectedTagsOptions, setSelectedTagsOptions] = React.useState([]);
  const handleTagChange = (selectedTagsOptions) => {
    const selectedLabels = selectedTagsOptions.map(option => option.label);
    setSelectedTagsOptions(selectedTagsOptions);
    handleInputChange(selectedLabels,'Tag');
  }
      React.useEffect(() => {
        if (props.data.length === 0) {
          setSelectedTagsOptions([]);
      } else {
          const tagArray = props.data.Tag?.split(",").map(tag => tag.trim());

          const tempArray = allTags.filter(obj =>
              tagArray.includes(obj.label)
          )

          setSelectedTagsOptions(tempArray);

      }
      }, [])
      React.useEffect(() => {
          if (!isGPUDataLoaded) {
              dispatch(fetchGPUData());
          }
      }, [isGPUDataLoaded])
      React.useEffect(() => {
        if (!isDistinctDataThroughSingleApiLoaded) {
          dispatch(getDistinctDataThroughSingleApi());
        }
      }, [isDistinctDataThroughSingleApiLoaded]);

  function formatDate(dateString) {
    const parts = dateString.split("/");
    if (parts.length === 3) {
      const [month, day, year] = parts;
      return `${month}/${day}/${year}`;
    }
    return "";
  }
  function formatDateAxios(dateString) {
    const parts = dateString.split("-");
    if (parts.length === 3) {
      const [year, month, day] = parts;
      return `${month}/${day}/${year}`;
    }
    return "";
  }
  const MultiSelectCheckbox = ({ selectedOptions, options, onChange }) => {
    const formattedOptions = options.map(option => ({
      value: option.label,
      label: option.label
    }));
    return (
      <Select
        closeMenuOnSelect={false}
        components={{ Option: CustomOption, ValueContainer: CustomValueContainer }}
        isMulti
        options={formattedOptions}
        hideSelectedOptions={false}
        controlShouldRenderValue={false}
        styles={customStyles}
        onChange={onChange}
        value={selectedOptions}
        inputValueRenderer={selectedOptions}
        placeholder="Choose Tags"
        onMenuOpen={() => {
          if (openDropdownId && openDropdownId !== 'Tags') {
            setOpenDropdownId(null); 
            setTimeout(() => setOpenDropdownId('Tags'), 0); 
          } else {
            setOpenDropdownId('Tags');
          }
        }}
        onMenuClose={() => setOpenDropdownId(null)}
        menuIsOpen={openDropdownId === 'Tags'} 
    

      />
    );
  };

  const handleInputChange = (e, keyvalue) => {
    const updatedJsonDataArray = selectedArray;
    if (keyvalue === "GPUSplitted") {
      selectedArray["GPUSplitted"] = e;
      updatedJsonDataArray["GPUSplitted"] = e;
      setSelectedArray(updatedJsonDataArray);
      return props.handleInputChange(updatedJsonDataArray);
      
    } 
      const newValue = e.target ? e.target.value : undefined;
      updatedJsonDataArray[keyvalue] =
      ["DateNeeded", "FullyAllocatedDate", "RequestDate", "EarmarkedDate"].includes(keyvalue)
      ? formatDate(newValue)
      : newValue;
      if(keyvalue === "Tag"){
        updatedJsonDataArray["Tag"] = e;
      }
    if ( ["DateNeeded", "FullyAllocatedDate", "RequestDate", "EarmarkedDate"].includes(keyvalue)) {
      const formatedDate = formatDateAxios(newValue);
      updatedJsonDataArray[keyvalue] = formatedDate;
    }
    if(["GPUsRequested", "GPUsAllocated"].includes(keyvalue)){
      updatedJsonDataArray[keyvalue] = parseInt(newValue)
    }
    else if (keyvalue === "GPU_Name") {

      setSelectedGPU(newValue);
      const newIndex = e.target.value;
      if (selectedArray["GPU_Name"] !== "") {
        if(props.errors.GPUsAllocated === "Please select a GPU"){
          props.setErrors(prevErrors => ({
            ...prevErrors,
            GPUsAllocated: "",
          }));       
        }
        let currentRegionData = gpuWiseRegionData[newIndex]
        if (!currentRegionData.find(item => item.Region === selectedArray['DC_RegionAllocated'])) {
          updatedJsonDataArray['DC_RegionAllocated'] = "";
        }
      }
      
      updatedJsonDataArray['DC_RegionAllocated'] = "";
      updatedJsonDataArray['GPUsAllocated'] = "";
    } else if(keyvalue === "DC_RegionAllocated" && newValue !== "" && props.errors.GPUsAllocated.includes("select DC_Region")){
        props.setErrors(prevErrors => ({
          ...prevErrors,
          GPUsAllocated: "",
        }));       
    }
    setSelectedArray(updatedJsonDataArray);
    props.handleInputChange(updatedJsonDataArray);
  };

  
  const setInputField = (propertySelected) => {
    let label = propertySelected.key;
    const handleDateInputFocus = () => {
      if (openDropdownId !== null) {
        setOpenDropdownId(null);
      }
    };
    if (label === "GPUsOwed") {
      const requestStatus = selectedArray["RequestStatus"];
      const isOwedCondition = ["Partially Allocated", "Fully Allocated"].includes(requestStatus);
      const requested = Math.max(0, parseInt(selectedArray["GPUsRequested"]) || 0);
      const allocated = Math.max(0, parseInt(selectedArray["GPUsAllocated"]) || 0);
      const owedValue = isOwedCondition ? requested - allocated : 0;
      return (
        <div className="input-container">
          <input
            type="number"
            className="custom-input"
            value={owedValue}
            placeholder="GPUs Owed"
            disabled={true}
          />
        </div>
      );
    }
    if (label === "RequestStatus") {
      return (
        <div className="input-container">
          <select
            style={{ marginRight: "10px" }}
            className="input-container-select"
            value={requestStatus}
            onChange={(event) => {
              const newValue = event.target.value;
              setRequestStatus(newValue); 
              handleInputChange(event, "RequestStatus");
              if (["Partially Allocated", "Fully Allocated"].includes(newValue)) {
                const allocatedGPUs = parseInt(selectedArray["GPUsAllocated"]) || 0;
                let capacity = [];
                if (selectedGPU) {
                  capacity = GPUData[selectedGPU].filter(
                    (item) => item.Region === selectedArray["DC_RegionAllocated"]
                  );
                }
                const availableGPUs = capacity[0]?.GPUsAvailable || 0; 
                if (allocatedGPUs > availableGPUs) {
                  setErrorField("GPUsAllocated");
                  setErrorLabel("GPU Granted cannot be greater than Available GPU");
                }
              } else {
                if (
                  errorField === "GPUsAllocated" &&
                  errorLabel === "GPU Granted cannot be greater than Available GPU"
                ) {
                  setErrorField("");
                  setErrorLabel("");
                }
              }
            }}
          >
            <option value="" disabled>
              Choose Request State
            </option>
            {requestStateOption?.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>

        </div>
      );
    } else if (label === "RI") {
      return (
        <div className="input-container">
          <select
            style={{ marginRight: "10px" }}
            className="input-container-select"
            value={selectedArray.RI || "" }
            onChange={(event) => handleInputChange(event, "RI")}
          >
            <option value="" disabled>
              Choose RI
            </option>
            {riOption?.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
          
        </div>
      );
    } else if (label === "Tag") {
      return (
        <div style={{width:'280px',border:'1px solid #888888', borderRadius:'5px'}}>
          <MultiSelectCheckbox options={allTags} selectedOptions={selectedTagsOptions} onChange={handleTagChange}/>
        </div>
      );
    }
    if (label === "RegionFlexibility") {
      return (
        <div className="input-container">
          <select
            style={{ marginRight: "10px" }}
            className="input-container-select"
            value={selectedArray.RegionFlexibility}
            onChange={(event) => {handleInputChange(event, "RegionFlexibility")}}
          >
            <option value="" disabled selected={selectedArray.RegionFlexibility === ""}>
              Choose Region Flexibility
            </option>
            {regionFlexibilityOptions?.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>

          
        </div>
      );
    } 
    else if (label === "RegionNeeded") {
      return (
        <div className="input-container">
          <input
            type="text"
            className="custom-input"
            defaultValue={selectedArray["RegionNeeded"]}
            placeholder="Enter Region"
           
            onChange={(event) => {
                 
                handleInputChange(event, "RegionNeeded");
              }
            }
          />
         
        </div>
      );
    }
    else if (label === "GPUsRequested") {
      return (
        <div className="input-container">
          <input
            type="number"
            className="custom-input"
            value={selectedArray[label]}
            min={0}
            placeholder={`Enter ${propertySelected.label}`}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) => {
              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                e.preventDefault();
              }
            }}
            onChange={(event) => {
                handleInputChange(event, label);
            }}
          />
          {props.errors.GPUsRequested?.length > 0 && (
            <span className="side-error">{props.errors.GPUsRequested}</span>
          )}
        </div>
      );
    }
    else if (label === "GPUsAllocated") {
      return (
        <div className="input-container">
          <input
            type="number"
            className="custom-input"
            value={selectedArray[label]}
            min={0}
            placeholder={`Enter ${propertySelected.label}`}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) => {
              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                e.preventDefault();
              }
            }}
            onFocus={() => {
              if (selectedArray["GPU_Name"] === "") {
                props.setErrors(prevErrors => ({
                  ...prevErrors,
                  GPUsAllocated: "Please select a GPU",
                }));       
              } else if (selectedArray["DC_RegionAllocated"] === "") {
                props.setErrors(prevErrors => ({
                  ...prevErrors,
                  GPUsAllocated: "Please select DC_RegionAllocated",
                }));                
              }
            }}
            onChange={(event) => {
              const value = parseInt(event.target.value, 10);
              if (event.target.value === "") {
                handleInputChange(event, label);
                props.setErrors(prevErrors => ({
                  ...prevErrors,
                  GPUsAllocated: "",
                }));
                return;
              }
              if (selectedArray["GPU_Name"] === "") {
                event.target.value = 0;
                handleInputChange(event, label);
                props.setErrors(prevErrors => ({
                  ...prevErrors,
                  GPUsAllocated: "Please select a GPU",
                }));       
                return;
              }

              if (selectedArray["DC_RegionAllocated"] === "") {
                event.target.value = 0;
                handleInputChange(event, label);
                props.setErrors(prevErrors => ({
                  ...prevErrors,
                  GPUsAllocated: "Please select DC_RegionAllocated",
                }));                
                return;
              }

              if (!isNaN(value)) {
               

                if (["Partially Allocated", "Fully Allocated"].includes(requestStatus)) {
                  let capacity = [];
                  if (selectedGPU) {
                    capacity = GPUData[selectedGPU].filter(
                      (item) => item.Region === selectedArray["DC_RegionAllocated"]
                    );
                  }
                  const availableGPUs = capacity[0]?.GPUsAvailable || 0;

                  if (value > availableGPUs) {
                    props.setErrors(prevErrors => ({
                      ...prevErrors,
                      GPUsAllocated: "GPU Granted cannot be greater than Available GPU",
                    }));
                  }
                }

                props.setErrors(prevErrors => ({
                  ...prevErrors,
                  GPUsAllocated: "",
                }));
                handleInputChange(event, label);
              }
            }}
          />
          {props.errors.GPUsAllocated.length > 0 && (
            <span className="side-error">{props.errors.GPUsAllocated}</span>
          )}
        </div>
      );
    }

    else if (label === "GPU_Name") {
      return (
        <>
          <div className="tooltip-wrapper">
            <select
              className="input-container-select tooltip-button"
              value={
                selectedGPU ? selectedGPU : selectedArray["GPU_Name"]
              }
              onChange={(event) => {
                handleInputChange(event, "GPU_Name");
                if (selectedArray["DC_RegionAllocated"] !== "") {
                  handleInputChange({ target: { value: "" } }, "DC_RegionAllocated");
                }
              }}
            >
              {selectedArray["GPU_Name"] === "" && (
                <option value="" disabled >
                  Choose GPU 
                </option>
              )}
              {gpuOptions?.map((item) => (
                <option value={item["Value"]}>{item["Value"]}</option>
              ))}
            </select>
            <div className="gpu">Changing the GPU will reset the DC Region Allocated and GPU Granted fields.</div>
          </div>
        </>
      );
    } else if (["DateNeeded", "FullyAllocatedDate", "RequestDate", "EarmarkedDate" ].includes(label)) {
      return (
        <>
          <div className="input-container">
            <input
              type="date"
              className="custom-input"
              onKeyDown={(event) => event.preventDefault()}
              onFocus={handleDateInputFocus}
              onClick={handleDateInputFocus}
              defaultValue={
                selectedArray[label]
                  ? moment(selectedArray[label], "MM/DD/YYYY").format(
                    "YYYY-MM-DD"
                  )
                  : ""
              }
              placeholder={`Enter ${propertySelected.label}`}
              onChange={(event) => {
                handleInputChange(event, label);
              }}
            />
          </div>
        </>
      );
    } 
    else if (label === "DC_RegionAllocated") {
      return (
        <>
          <div className="input-container">
            <select
               style={{ marginRight: "10px" }}
            className="input-container-select"
            defaultValue={selectedArray["DC_RegionAllocated"]}
            onFocus={() => {
              if (selectedArray["GPU_Name"] === "") {
                props.setErrors(prevErrors => ({
                  ...prevErrors,
                  DC_RegionAllocated: "Please select a GPU",
                }));       
                
              }
            }}
            onChange={(event) => {
              if (selectedArray["GPU_Name"] === "") {
                props.setErrors(prevErrors => ({
                  ...prevErrors,
                  DC_RegionAllocated: "Please select a GPU",
                }));       

                
              } else {
                props.setErrors(prevErrors => ({
                  ...prevErrors,
                  DC_RegionAllocated: "",
                }));       

                handleInputChange(event, "DC_RegionAllocated");
              }
            }}
            >
              <option
                style={{ color: '#00000029' }} value={''} selected={selectedArray["DC_RegionAllocated"] === ""} disabled={true}>Choose Region</option>
             {selectedGPU && gpuWiseRegionData[selectedGPU]?.map((item) => (
              <option value={item}>{item}</option>
            ))}
            </select>
            {props.errors.DC_RegionAllocated?.length > 0 && (
            <span className="side-error">{props.errors.DC_RegionAllocated}</span>
          )}
          </div>
        </>
      );
    } 
    else {
      return (
        <>
          <div
            className="input-container"
          >
            <input
              style={{ marginRight: "10px" }}
              type={["GPUsAllocated", "GPUsRequested"].includes(label) ? "number" : "text"}
              className="custom-input"
              defaultValue={
                selectedArray[label]
              }
              onWheel={(e) => e.target.blur()}
              onKeyDown={(e) => {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                  e.preventDefault();
                }
              }}
              placeholder={`Enter ${propertySelected.label}`}
              onChange={(event) => {
                
                  handleInputChange(event, label);
              }}
            />
        
            {propertySelected.key === "CustomerName" && props.errors.CustomerName.length>0 && (
              <span className="side-error">
                Customer Name cannot be empty
              </span>
            )}
          </div>
        </>
      );
    }
  };
  return (
    <>
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          border: "3px solid #ccc",
        }}
      >
        <tbody>
          {tableFormat.LabelKeyPair?.map((property, index) => {
            return (
              <tr key={index}>
                <th style={{ ...headerStyle, border: "1px solid #ccc", width: "25%" }}>
                  {property.label} <span style={{ color: "red" }}>{property.key === "CustomerName" ? "*" : ""}</span>
                </th>   
                <td
                  style={{
                    ...bodyStyle,
                    backgroundColor: "#f6f6f6",
                    border: "1px solid #ccc",
                  }}
                >
                  {setInputField(property)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {props.notes.length > 0 && (
        <>
          <div
            style={{
              fontFamily: "Segoe UI",
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "20px",
              letterSpacing: "0px",
              marginTop: "10px",
            }}
          >
            NOTES
          </div>
          {props.notes.map((item, index) => {
            return (
              <div
                key={index}
                style={{
                  flexDirection: "column",
                  marginTop: "0.6rem",
                }}
              >
                <div
                  style={{
                    fontFamily: "Segoe UI",
                    fontSize: "14px",
                    fontWeight: 700,
                    lineHeight: "20px",
                    letterSpacing: "0px",
                    color: "#1f1f1f",
                  }}
                >
                  {item.User}{" "}
                  <span
                    style={{
                      marginLeft: "10px",
                      fontSize: "12px",
                      fontWeight: 400,
                    }}
                  >
                    {item.Date}
                  </span>
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    color: "#181818",
                    marginBottom: "10px",
                  }}
                >
                  {item.Notes}
                </div>
                {index < props.notes.length - 1 && <hr color="#eaeaea" />}
              </div>
            );
          })}
        </>
      )}
      {props.notesLoader && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
    </>
  );
}

const headerStyle = {
  fontFamily: "Segoe UI",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0px",
  textAlign: "left",
  backgroundColor: "#F6F6F6",
  height: "30px",
  padding: "3px"
};

const bodyStyle = {
  fontFamily: "Segoe UI",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0px",
  textAlign: "left",
  height: "30px",
  padding: "10px",
};

export default EditRequest;
